import React, { useState, useEffect, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { formatDate, formatTime } from "../../../constants/helper";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import { ShowTableDaftarStokBpkb } from "../../../components/ShowTable";
import { SearchBar, Loader, ScrollToTop } from "../../../components";
import {
  Box,
  TextField,
  Typography,
  Divider,
  Pagination,
  Button,
  ButtonGroup,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
} from "@mui/material";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import DownloadIcon from "@mui/icons-material/Download";
import PrintIcon from "@mui/icons-material/Print";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import EditIcon from "@mui/icons-material/Edit";

const TampilDaftarStokBpkb = () => {
  let navigate = useNavigate();
  const { user, setting, dispatch } = useContext(AuthContext);
  const location = useLocation();
  const id = location.pathname.split("/")[2];
  const { screenSize } = useStateContext();

  const [isDaftarStokBpkbsExist, setIsDaftarStokBpkbsExist] = useState(false);
  const [lokasi, setLokasi] = useState("KANTOR");
  const [tanggalPindahLokasi, setTanggalPindahLokasi] = useState(new Date());
  const [keteranganLokasi, setKeteranganLokasi] = useState("");
  const [noBeli, setNoBeli] = useState("");
  const [tanggalBeli, setTanggalBeli] = useState("");
  const [supplier, setSupplier] = useState("");
  const [merk, setMerk] = useState("");
  const [tipe, setTipe] = useState("");
  const [noRangka, setNoRangka] = useState("");
  const [noMesin, setNoMesin] = useState("");
  const [nopol, setNopol] = useState("");
  const [namaStnk, setNamaStnk] = useState("");
  const [noBpkb, setNoBpkb] = useState("");
  const [alamatStnk, setAlamatStnk] = useState("");
  const [tglStnk, setTglStnk] = useState("");
  const [jenisBeli, setJenisBeli] = useState("");
  const [hargaSatuan, setHargaSatuan] = useState("");
  const [tanggalJual, setTanggalJual] = useState("");
  const [noJual, setNoJual] = useState("");
  const [namaRegister, setNamaRegister] = useState("");
  const [sisaBulan, setSisaBulan] = useState("");
  const [namaWarna, setNamaWarna] = useState("");
  const [tahun, setTahun] = useState("");
  const [totalBiayaPerawatan, setTotalBiayaPerawatan] = useState("");
  const [value, setValue] = useState("KANTOR");
  const [searchTerm, setSearchTerm] = useState("");
  const [daftarStokBpkbsData, setDaftarStokBpkbsData] = useState([]);

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  const textRightSmall = {
    textAlign: screenSize >= 650 && "right",
    fontSize: "13px",
  };

  const columns = [
    { title: "No", field: "no" },
    { title: "No. Kontrak", field: "noJual" },
    { title: "Tanggal", field: "tanggalJual" },
    { title: "No. Polisi", field: "nopol" },
    { title: "Nama STNK", field: "namaStnk" },
    { title: "Alamat STNK", field: "alamatStnk" },
    { title: "Tahun", field: "tahun" },
    { title: "Warna", field: "warna" },
    { title: "No. Rangka", field: "noRangka" },
    { title: "No. Mesin", field: "noMesin" },
  ];

  const [loading, setLoading] = useState(false);
  let [page, setPage] = useState(0);
  const [limit, setLimit] = useState(20);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [query, setQuery] = useState("");

  const handleChange = (e, p) => {
    setPage(p - 1);
  };

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setSearchTerm(query);
  };

  const handleChangeLaporan = (event) => {
    setValue(event.target.value);
  };

  useEffect(() => {
    id ? getDaftarStokById() : setIsDaftarStokBpkbsExist(false);
  }, [id]);

  useEffect(() => {
    getDaftarStokBpkbsData();
  }, [value, page, searchTerm]);

  const getDataForDocs = async (pdf, excel) => {
    setLoading(true);
    let response = await axios.post(`${tempUrl}/daftarStoksBpkbDoc`, {
      lokasi: value,
      id: user._id,
      token: user.token,
      kodeCabang: user.cabang._id,
    });

    setLoading(false);
    if (pdf) {
      downloadPdf(response.data);
    } else {
      downloadExcel(response.data);
    }
  };

  const getDaftarStokBpkbsData = async () => {
    setLoading(true);
    let response = await axios.post(
      `${tempUrl}/daftarStoksBpkbPagination?search_query=${searchTerm}&page=${page}&limit=${limit}`,
      {
        lokasi: value,
        id: user._id,
        token: user.token,
        kodeCabang: user.cabang._id,
      }
    );

    setQuery(searchTerm);
    setDaftarStokBpkbsData(response.data.daftarStoks);
    setPage(response.data.page);
    setPages(response.data.totalPage);
    setRows(response.data.totalRows);
    setLoading(false);
  };

  const getDaftarStokById = async () => {
    setLoading(true);
    if (id) {
      const response = await axios.post(`${tempUrl}/daftarStoks/${id}`, {
        id: user._id,
        token: user.token,
      });
      setIsDaftarStokBpkbsExist(true);
      setLokasi(response.data.lokasi);
      setTanggalPindahLokasi(
        response.data.tanggalPindahLokasi &&
          formatDate(response.data.tanggalPindahLokasi)
      );
      setKeteranganLokasi(response.data.keteranganLokasi);
      setNoBeli(response.data.noBeli);
      setTanggalBeli(formatDate(response.data.tanggalBeli));
      setSupplier(response.data.supplier);
      setMerk(response.data.merk);
      setTipe(response.data.tipe);
      setNoRangka(response.data.noRangka);
      setNoMesin(response.data.noMesin);
      setNopol(response.data.nopol);
      setNamaWarna(response.data.namaWarna);
      setTahun(response.data.tahun);
      setNamaStnk(response.data.namaStnk);
      setNoBpkb(response.data.noBpkb);
      setAlamatStnk(response.data.alamatStnk);
      setTglStnk(formatDate(response.data.tglStnk));
      setJenisBeli(response.data.jenisBeli);
      setHargaSatuan(response.data.hargaSatuan);
      setTanggalJual(response.data.tanggalJual);
      setNoJual(response.data.noJual);
      setTotalBiayaPerawatan(response.data.totalBiayaPerawatan);

      const findJual = await axios.post(`${tempUrl}/jualByNoJualAllCabang`, {
        noJual: response.data.noJual,
        id: user._id,
        token: user.token,
      });
      setNamaRegister(findJual.data.namaRegister);
      setSisaBulan(findJual.data.sisaBulan);
    }
    setLoading(false);
  };

  const downloadPdf = (data) => {
    let tempSubGroupHeight = 35;
    let tempHeight = 35;
    var date = new Date();
    var current_date = formatDate(date);
    var current_time = formatTime(date);
    const doc = new jsPDF("l", "mm", [400, 282]);
    doc.setFontSize(12);
    doc.text(`${setting.namaPerusahaan} - ${setting.kotaPerusahaan}`, 15, 10);
    doc.text(`${setting.lokasiPerusahaan}`, 15, 15);
    doc.setFontSize(16);
    doc.text(`Daftar Stok BPKB`, 190, 30);
    doc.setFontSize(10);
    doc.text(
      `Dicetak Oleh: ${user.username} | Tanggal : ${current_date} | Jam : ${current_time}`,
      15,
      290
    );
    doc.autoTable({
      startY: doc.pageCount > 1 ? doc.autoTableEndPosY() + 20 : 40,
      columns: columns.map((col) => ({ ...col, dataKey: col.field })),
      body: data,
      headStyles: {
        fillColor: [117, 117, 117],
        color: [0, 0, 0],
      },
      didDrawPage: (d) => {
        tempSubGroupHeight = d.cursor.y;
        tempHeight = d.cursor.y;
      },
      columnStyles: {
        0: { cellWidth: 10 },
        1: { cellWidth: 30 },
        2: { cellWidth: 25 },
        3: { cellWidth: 35 },
        4: { cellWidth: 40 },
        5: { cellWidth: 40 },
        6: { cellWidth: 25 },
        7: { cellWidth: 25 },
        8: { cellWidth: 35 },
        9: { cellWidth: 35 },
        10: { cellWidth: 20 },
        11: { cellWidth: 20 },
        12: { cellWidth: 20 },
        13: { cellWidth: 20 },
        // etc
      },
    });
    window.open(URL.createObjectURL(doc.output("blob")));
  };

  const downloadPdfTandaTerimaBpkb = async () => {
    let tempYTitle = 20;
    let tempY = 30;

    const doc = new jsPDF();

    // Convert JPG file to Base64 Data URL
    const toDataURL = (url) =>
      fetch(url)
        .then((response) => response.blob())
        .then(
          (blob) =>
            new Promise((resolve) => {
              const reader = new FileReader();
              reader.onloadend = () => resolve(reader.result);
              reader.readAsDataURL(blob);
            })
        );

    // Load the JPG from public folder
    const imgData = await toDataURL("/LogoPerusahaan.jpg"); // make sure the image is in public/

    // Add image to PDF
    doc.addImage(imgData, "JPEG", 15, 10, 50, 20);

    doc.setFontSize(16);
    doc.setFont(undefined, "bold");
    doc.text(`TANDA TERIMA BPKB`, 75, tempYTitle);
    const textWidth = doc.getTextWidth(`TANDA TERIMA BPKB`);
    doc.setLineWidth(0.8);
    doc.line(
      75, // start X
      tempYTitle + 1, // start Y (slightly below text)
      75 + textWidth, // end X (start X + text width)
      tempYTitle + 1 // end Y (same as start Y to make it straight)
    );
    doc.setFont(undefined, "normal");
    doc.setFontSize(11);
    tempY += 6;
    doc.text(`Diterima dari`, 15, tempY);
    doc.text(`: SJM`, 55, tempY);
    tempY += 6;
    doc.text(`Diterima oleh`, 15, tempY);
    doc.text(`: ${namaRegister}`, 55, tempY);
    tempY += 6;
    doc.text(`BPKB`, 15, tempY);
    doc.text(`- No. Polisi`, 55, tempY);
    doc.text(`: ${nopol}`, 95, tempY);
    tempY += 6;
    doc.text(`  No. BPKB`, 55, tempY);
    doc.text(`:`, 95, tempY);
    tempY += 6;
    doc.text(`  BPKB a.n`, 55, tempY);
    doc.text(`:`, 95, tempY);
    tempY += 6;
    doc.text(`  Merk / Tipe`, 55, tempY);
    doc.text(`: ${merk} / ${tipe}`, 95, tempY);
    tempY += 6;
    doc.text(`  Warna / Tahun`, 55, tempY);
    doc.text(`: ${namaWarna} / ${tahun}`, 95, tempY);
    tempY += 6;
    doc.text(`  No. Rangka`, 55, tempY);
    doc.text(`: ${noRangka}`, 95, tempY);
    tempY += 6;
    doc.text(`  No. Mesin`, 55, tempY);
    doc.text(`: ${noMesin}`, 95, tempY);
    tempY += 6;
    doc.text(`  Kelengkapan`, 55, tempY);
    doc.text(`:`, 95, tempY);
    tempY += 6;
    doc.text(`Keterangan`, 15, tempY);
    doc.text(`- LUNAS`, 55, tempY);
    doc.text(`: Pelunasan Angsuran. Kontrak TGL.`, 95, tempY);

    tempY += 10;
    doc.text(`Jakarta, ${tanggalPindahLokasi}`, 140, tempY);
    tempY += 6;
    doc.text(`Diserahkan oleh,`, 25, tempY);
    doc.text(`Dicek oleh,`, 85, tempY);
    doc.text(`Diterima oleh,`, 145, tempY);
    tempY += 25;
    doc.text(`${namaRegister}`, 140, tempY);
    doc.setFontSize(12);
    window.open(URL.createObjectURL(doc.output("blob")));
  };

  const downloadExcel = (data) => {
    const workSheet = XLSX.utils.json_to_sheet(data);
    const workBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, `Daftar Stok BPKB`);
    // Buffer
    let buf = XLSX.write(workBook, { bookType: "xlsx", type: "buffer" });
    // Binary String
    XLSX.write(workBook, { bookType: "xlsx", type: "binary" });
    // Download
    XLSX.writeFile(workBook, `daftarStokBpkb.xlsx`);
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <Box>
      <ScrollToTop />
      {isDaftarStokBpkbsExist && (
        <Button
          variant="outlined"
          color="secondary"
          onClick={() => navigate("/daftarStokBpkb")}
          sx={{ marginLeft: 2, marginTop: 4, marginBottom: 2 }}
        >
          {"< Kembali"}
        </Button>
      )}
      <Typography color="#757575">Stok</Typography>
      <Typography variant="h4" sx={subTitleText}>
        Daftar Stok BPKB
      </Typography>
      {!id && (
        <>
          <Box sx={downloadButtons}>
            <ButtonGroup variant="outlined" color="secondary">
              <Button
                variant="contained"
                onClick={() => getDataForDocs(true, false)}
              >
                Cetak
              </Button>
              <Button
                startIcon={<DownloadIcon />}
                onClick={() => getDataForDocs(false, true)}
              >
                EXCEL
              </Button>
            </ButtonGroup>
          </Box>
          <Divider sx={dividerStyle} />
          <FormControl sx={{ marginTop: 1 }}>
            <FormLabel id="demo-controlled-radio-buttons-group">
              Laporan
            </FormLabel>
            <RadioGroup
              row
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              defaultValue="KANTOR"
              value={value}
              onChange={handleChangeLaporan}
            >
              <FormControlLabel
                value="KANTOR"
                control={<Radio />}
                label="Kantor"
              />
              <FormControlLabel
                value="SUDAH DIAMBIL"
                control={<Radio />}
                label="Sudah Diambil"
              />
            </RadioGroup>
          </FormControl>
        </>
      )}
      <Divider sx={{ marginTop: 1 }} />
      {isDaftarStokBpkbsExist && lokasi === "SUDAH DIAMBIL" && (
        <Box sx={downloadButtons}>
          <ButtonGroup variant="outlined" color="secondary">
            <Button
              variant="contained"
              startIcon={<PrintIcon />}
              onClick={() => downloadPdfTandaTerimaBpkb()}
            >
              Tanda Terima BPKB
            </Button>
          </ButtonGroup>
        </Box>
      )}
      {isDaftarStokBpkbsExist && sisaBulan === 0 && (
        <Box sx={buttonModifierContainer}>
          <ButtonGroup variant="contained">
            <Button
              color="primary"
              startIcon={<EditIcon />}
              sx={{ textTransform: "none" }}
              onClick={() => {
                navigate(`/daftarStokBpkb/${id}/edit`);
              }}
            >
              Ubah
            </Button>
          </ButtonGroup>
        </Box>
      )}
      {isDaftarStokBpkbsExist && (
        <>
          <Box sx={showDataContainer}>
            <Box sx={showDataWrapper}>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="3" style={textRight}>
                      Lokasi :
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control value={lokasi} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="3" style={textRight}>
                      Tanggal :
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control value={tanggalPindahLokasi} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="3" style={textRight}>
                      Keterangan :
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        as="textarea"
                        rows={3}
                        value={keteranganLokasi}
                        disabled
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="3" style={textRight}>
                      No. Beli :
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control value={noBeli} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="3" style={textRight}>
                      Tanggal Beli :
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control value={tanggalBeli} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="3" style={textRight}>
                      Supplier :
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        value={`${supplier ? supplier.kodeSupplier : ""} - ${
                          supplier ? supplier.namaSupplier : ""
                        }
                      `}
                        disabled
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="3" style={textRight}>
                      Merk :
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control value={merk} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="3" style={textRight}>
                      Tipe :
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control value={tipe} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="3" style={textRight}>
                      Nama Warna :
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control value={namaWarna} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="3" style={textRight}>
                      Tahun :
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control value={tahun} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="3" style={textRightSmall}>
                      Total Biaya Perawatan :
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        value={totalBiayaPerawatan.toLocaleString("en-US")}
                        disabled
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
            </Box>
            <Box sx={[showDataWrapper, secondWrapper]}>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="3" style={textRight}>
                      No. Rangka :
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control value={noRangka} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="3" style={textRight}>
                      No. Mesin :
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control value={noMesin} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="3" style={textRight}>
                      Nopol :
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control value={nopol} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="3" style={textRight}>
                      Nama STNK :
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control value={namaStnk} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="3" style={textRight}>
                      No. Bpkb :
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control value={noBpkb} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="3" style={textRight}>
                      Alamat STNK :
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control value={alamatStnk} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="3" style={textRight}>
                      Tanggal Plat STNK :
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control value={tglStnk} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="3" style={textRight}>
                      Jenis Beli :
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control value={jenisBeli} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="3" style={textRight}>
                      Harga Satuan :
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        value={hargaSatuan.toLocaleString("en-US")}
                        disabled
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
            </Box>
          </Box>
          <Divider sx={dividerStyle} />
        </>
      )}
      {!id && (
        <>
          <Form onSubmit={searchData}>
            <Box sx={searchBarContainer}>
              <SearchBar value={query} setSearchTerm={setQuery} />
              <Button
                variant="contained"
                type="submit"
                color="primary"
                disableElevation
              >
                Cari
              </Button>
            </Box>
          </Form>
          <Box sx={tableContainer}>
            <ShowTableDaftarStokBpkb currentPosts={daftarStokBpkbsData} />
          </Box>
          <Box sx={tableContainer}>
            <Pagination
              count={pages}
              page={page + 1}
              onChange={handleChange}
              color="primary"
              size={screenSize <= 600 ? "small" : "large"}
            />
          </Box>
        </>
      )}
    </Box>
  );
};

export default TampilDaftarStokBpkb;

const subTitleText = {
  fontWeight: "900",
};

const dividerStyle = {
  pt: 4,
};

const showDataContainer = {
  mt: 4,
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const showDataWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const searchBarContainer = {
  pt: 6,
  display: "flex",
  justifyContent: "center",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};

const labelInput = {
  fontWeight: "600",
  marginLeft: 1,
};

const spacingTop = {
  mt: 4,
};

const secondWrapper = {
  marginLeft: {
    sm: 4,
  },
  marginTop: {
    sm: 0,
    xs: 4,
  },
};

const downloadButtons = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const buttonModifierContainer = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};
